import React, { ReactNode, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

interface AnimateHeightProps {
	children: ReactNode;
	visible: boolean;
	duration?: number;
}

export default function AnimateHeight({
	children,
	visible,
	duration = 250,
}: AnimateHeightProps) {
	const [elementAnimatedIn, setElementAnimatedIn] = useState(visible);

	const elementRef = useRef<HTMLDivElement>(null);

	return (
		<CSSTransition
			in={visible}
			nodeRef={elementRef}
			timeout={duration}
			classNames="animate-height"
			onEntered={() => setElementAnimatedIn(true)}
			onExit={() => setElementAnimatedIn(false)}
			unmountOnExit
			data-testid="animate-height"
		>
			<div className="animate-height" ref={elementRef}>
				<div
					className="animate-container"
					style={
						elementAnimatedIn
							? {}
							: { overflow: 'hidden' }
					}
				>
					{children}
				</div>
			</div>
		</CSSTransition>
	);
}
